import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { TransportGroupRoundedIcon } from 'app/icons';
import { TransportGroupForm } from 'app/pages/TransportGroup';
import { useAsyncAction } from 'app/services';
import { transportGroupCreate } from 'app/store/transport';
import React, { useEffect, useRef } from 'react';

const TransportGroupDialog = (props) => {
  const formRef = useRef();
  const { open, onClose } = props;

  const {
    asyncAction: createSubmit,
    isLoading: isCreateLoading,
    isSuccessful: isCreateSuccessful,
    isError: isCreateError,
  } = useAsyncAction(transportGroupCreate, [open]);

  const handleFormClick = () => {
    formRef.current?.handleFormSubmit();
  };

  const handleFormSubmit = (params) => {
    createSubmit(params);
  };

  useEffect(() => {
    if (isCreateSuccessful) {
      onClose();
    }
  }, [isCreateSuccessful]);

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={open}
      onClose={onClose}
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.MuiDialog-paper': {
          minWidth: '460px',
        },
        '.MuiDialogTitle-root': {
          display: 'flex',
          padding: theme.spacing(2),
          alignItems: 'center',
        },
        '.MuiDialogTitle-root .MuiTypography-root': {
          marginLeft: theme.spacing(1.5),
        },
        '.MuiDialogTitle-root .MuiButtonBase-root': {
          marginLeft: 'auto',
        },
        '.MuiDialogContent-root': {
          padding: theme.spacing(0),
        },
        '.MuiDialogContent-root .simplebar-container': {
          padding: theme.spacing(0, 2),
        },
        '.MuiDialogActions-root': {
          padding: theme.spacing(2),
          justifyContent: 'flex-end',
        },
        '.MuiAvatar-circular': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
          svg: {
            width: '18px',
            height: '18px',
          },
          'path, circle': {
            fill: theme.palette.primary.main,
          },
        },
        '.MuiAlert-root': {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(2),
          borderRadius: theme.shape.borderRadius,
        },
      })}>
      <DialogTitle>
        <Avatar>
          <TransportGroupRoundedIcon fontSize='small' />
        </Avatar>
        <Typography component='p'>Добавить группу транспорта</Typography>
        <IconButton color='default' onClick={onClose}>
          <Close fontSize='small' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Scrollbar>
          <TransportGroupForm ref={formRef} onSubmit={handleFormSubmit} />
          {!isCreateLoading && isCreateError && (
            <Alert severity='error'>
              Произошла ошибка при добавлении группы геозон. Попробуйте снова или обратитесь в техническую поддержку.
            </Alert>
          )}
        </Scrollbar>
      </DialogContent>
      <DialogActions>
        <LoadingButton variant='contained' loading={isCreateLoading} onClick={handleFormClick} disableElevation>
          Добавить
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default TransportGroupDialog;
